// extracted by mini-css-extract-plugin
export default {"bars":"Bars_bars__KUX3V","axis":"Bars_axis__bB7S3","x":"Bars_x__O9jg8","tooltip":"Bars_tooltip__HUz64"};